import {GraphHandleStyle} from '../components/GraphHandle';

import {defineGraphPartsStyleConfig, defineGraphStyleConfig} from './config';
import {controlGroupStyle} from './control-group-theme';
import {controlCssVars, controlStyle} from './control-theme';
import {controlsCssVars, controlsStyle} from './controls-theme';
import {nodeCSSVars} from './css-vars';

const baseStyle = defineGraphPartsStyleConfig(props => ({
  container: {
    // We use as "any" since typescript is not able to infer the type of the object (recursive)
    ...(GraphHandleStyle as any),
    ...controlsCssVars,
    ...controlCssVars,
    ...nodeCSSVars(props),
  },
  controls: controlsStyle(props),
  control: controlStyle,
  'control-group': controlGroupStyle(props),
}));

export const GraphTheme = defineGraphStyleConfig({
  baseStyle,
});
